module.exports = __webpack_public_path__ + "image/update-bond.b8e5966.png";